package org.moxultimate.topwithmox.components.buttons

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.ButtonVars
import org.jetbrains.compose.web.css.em
import org.moxultimate.topwithmox.theme.CircleButtonVariant
import org.moxultimate.topwithmox.theme.ColoredButtonVariant
import org.moxultimate.topwithmox.theme.UncoloredButtonVariant

@Composable
fun IconButton(
    onClick: () -> Unit,
    colored : Boolean = false,
    content: @Composable () -> Unit)
{
    val colorVariant = if (colored) ColoredButtonVariant else UncoloredButtonVariant

    Button(
        onClick = { onClick() },
        Modifier.setVariable(ButtonVars.FontSize, 1.em), // Make button icon size relative to parent container font size
        variant = CircleButtonVariant.then(colorVariant)
    ) {
        content()
    }


}
